import React from "react";
import "./ExchangeInfo.css";
import stars from "../../../assets/stars.svg";
import check from "../../../assets/check.svg";

const ExchangeInfo = () => {
    return (
        <div className="exchange-info">
            <h1>Быстрый обмен<br />Криптовалют</h1>

            <ul>
                <li>
                    <img src={check} alt="✔" className="check-icon" />
                    Быстрый, простой, не связанный с хранением
                </li>
                <li>
                    <img src={check} alt="✔" className="check-icon" />
                    Exchange-сервис с более чем 150 криптовалютами
                </li>
            </ul>


            <a
                className="trustpilot-text"
                href=""
                target="_blank"
                rel="noopener noreferrer"
            >
                Отличный рейтинг на Trustpilot
            </a>
        </div>
    );
};

export default ExchangeInfo;
